export class ErrorHandlingService {
  static logError(error, errorInfo = {}) {
    const timestamp = new Date().toISOString();
    const errorLog = {
      timestamp,
      error: {
        message: error.message,
        stack: error.stack,
        ...errorInfo,
      },
    };

    if (
      // eslint-disable-next-line no-undef
      process.env.ENVIRONMENT === 'local' ||
      // eslint-disable-next-line no-undef
      process.env.ENVIRONMENT === 'development'
    ) {
      console.error('Error logged:', errorLog);
    }
  }

  static getErrorStatusCode(error) {
    if (error.response) {
      return error.response.status;
    }
    if (error.message?.includes('404')) return 404;
    if (error.message?.includes('403')) return 403;
    return 500;
  }
}
